/**
 * User: mphee
 * Date: 1/4/13
 * Time: 2:26 PM
 */

define(function (require) {
  'use strict';
  var $ = require('jquery');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var ClassTimer = require('common/ClassTimer');
  var Const = require('common/Const');
  var CommonFunctions = require('common/CommonFunctions');
  const oeNotificationService = oeApp.getData('common').oeNotificationServiceHost;
  const personId = oeApp.getData('person').id;
  const token = CommonFunctions.getCookie('OESSOTOK');

  return {
    liveClassPollActive: false,

    confirm: function (notification) {
      if (notification.id === 0) {
        return;
      }

      $.ajax({
        url: oeNotificationService + '/notifications/confirm/' + personId + '/' + notification.id,
        type: 'POST',
        dataType: 'text',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        success: function () {
          CommonFunctions.sendReadConfirmationToAngular(notification.id);
        },
      });
    },

    deleteNotification: function (notification) {
      if (notification.id === 0) {
        return;
      }

      return $.ajax({
        url: oeNotificationService + '/notifications/delete/' + notification.id + '/' + personId,
        dataType: 'text',
        type: 'PUT',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        success: function (notification) {
          console.log('Marking notification deleted');
          Backbone.trigger('notifications:onConfirmed', notification);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('Failed marking notification deleted, error:' + errorThrown);
        },
      });
    },

    poll: function (forceUpdate) {
      $.ajax({
        url: oeNotificationService + '/notifications/cnt/' + personId,
        headers: {
          Authorization: 'Bearer ' + token,
        },
        context: this,
        success: function (data) {
          if (data.notiCnt != null || forceUpdate) {
            data = this._prepareData(data);
            Backbone.trigger('notifications:onNew', data);
          } else {
            Backbone.trigger('notifications:onHideLiveClassStarting', data);
          }
        },
        complete: function () {
          var pollTime = oeApp.hasData('common') ? oeApp.getData('common').notificationsPollTimeMS || 0 : 300000;
          if (pollTime > 0) {
            if (this.notiTimeout) {
              clearTimeout(this.notiTimeout);
            }

            this.notiTimeout = setTimeout(_.bind(this.poll, this), pollTime);
          }
        },
      });
    },

    //TODO wrap with Togglz
    pollLiveClassNotifications: function () {
      var tenMinutesInMS = 600000;
      // Get time from LiveClassBase
      var timeToSignedupClass = window.localStorage ? window.localStorage.getItem('timeToSignedupClass') : null;
      var now = new Date().getTime();
      var pollTime;

      if (this.liveClassPollActive) {
        // We are in the 10 minute window before classStart, poll now, and start aggressive 30 sec polling
        $.ajax({
          url: '/notifications/?type=3&type=14&type=17',
          context: this,
          success: function (data) {
            if (data.notiCnt != null) {
              data = this._prepareData(data);
              Backbone.trigger('notifications:onNew', data);
            } else {
              Backbone.trigger('notifications:onHideLiveClassStarting', data);
            }
          },
        });

        pollTime = 30000;
      } else if (timeToSignedupClass && now < timeToSignedupClass - tenMinutesInMS) {
        // We are before the 10 minute window before classStart, set next poll to classStart - 10 minutes
        pollTime = timeToSignedupClass - tenMinutesInMS - now;
      } else {
        // timeToSignedClass is null or we are past the timeToSignedupClass, poll at regular notification intervals
        pollTime = oeApp.hasData('common') ? oeApp.getData('common').notificationsPollTimeMS || 0 : 300000;
      }

      if (pollTime > 0) {
        if (this.lcnTimeout) {
          clearTimeout(this.lcnTimeout);
        }

        this.lcnTimeout = setTimeout(this.pollLiveClassNotifications, pollTime);
      }
    },

    startLiveClassPolling: function (endPollTime) {
      if (!this.liveClassPollActive) {
        this.liveClassPollActive = true;

        // Start the 30 second polling, but no need to do it immediately, LCS probably won't have run right away
        this.pollLiveClassNotifications = _.bind(this.pollLiveClassNotifications, this);
        this.lcnTimeout = setTimeout(this.pollLiveClassNotifications, 30000);
      }

      if (endPollTime) {
        var msToEndPollTime = endPollTime - new Date().valueOf();
        CommonFunctions.setItemIntoLocalStorage('liveClassPollActive', endPollTime);
        this.lcnTimeout = setTimeout(_.bind(this.stopLiveClassPolling, this), msToEndPollTime);
      }
    },

    stopLiveClassPolling: function () {
      this.liveClassPollActive = false;
      CommonFunctions.removeItemFromLocalStorage('liveClassPollActive');

      // Stop the timeout interval
      if (this.lcnTimeout) {
        clearTimeout(this.lcnTimeout);
      }
    },

    initialize: function () {
      Backbone.on('notifications:onConfirm', _.bind(this.deleteNotification, this));
    },

    start: function () {
      this.poll(true);
    },

    _prepareData: function (data) {
      data.notifications = data.notifications[1];

      _.each(data.notifications, function (notification) {
        if (Const.NOTIFICATION_ENUM.ACCOUNT_STATUS == notification.type) {
          notification.priority = 1;
        } else if (Const.NOTIFICATION_ENUM.LIVE_STARTING == notification.type) {
          // This will also currently catch Live Class Reminder - but that currently doesn't matter.
          notification.priority = 2;
        } else if (Const.NOTIFICATION_ENUM.WELCOME_CALL == notification.type) {
          notification.priority = 3;
        } else if (Const.NOTIFICATION_ENUM.LIVE_CLASS_DENIED == notification.type) {
          notification.priority = 4;
        } else if (Const.NOTIFICATION_ENUM.GEAR_CHECK == notification.type) {
          notification.priority = 5;
        } else if (Const.NOTIFICATION_ENUM.LIVE_SURVEY == notification.type) {
          notification.priority = 6;
        } else if (Const.NOTIFICATION_ENUM.DELINQUENT_ACCOUNT_STATUS == notification.type) {
          notification.priority = 7;
        } else {
          notification.priority = 8;
        }
      });

      return data;
    },
  };
});



//////////////////
// WEBPACK FOOTER
// ./js/common/NotificationListener.js
// module id = 257
// module chunks = 27 28 29